module.exports = __webpack_public_path__ + "img/edit-white-18dp.27d86101.svg";